import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicOdemela from "../Components/ProjPicOdemela";

const ProjectPageOdemela = () => {
    return (
        <>
            <Navbar />
            <ProjPicOdemela />
            <Footer />
        </>
    );
};

export default ProjectPageOdemela;
